export default __webpack_public_path__ + "static/media/commingSoonAr.33bed825.png";